import React from 'react';
import { ModalButton } from 'baseui/modal';
import { KIND as ButtonKind } from 'baseui/button';

import { ICustomFooterProps } from './type';

const CustomFooter: React.FC<ICustomFooterProps> = (props) => {
	const { agreeLabel = 'Yes', disagreeLabel = 'No', onAgreeClick, onDisagreeClick } = props;

	return (
		<>
			<ModalButton onClick={onDisagreeClick} kind={ButtonKind.tertiary}>
				{disagreeLabel}
			</ModalButton>
			<ModalButton onClick={onAgreeClick}>{agreeLabel}</ModalButton>
		</>
	);
};

export default CustomFooter;
